module.exports = __webpack_public_path__ + "static/media/TrashWhiteTransparent.ffeeae60.svg";